import { ApiClientService, EntityApiService, RequestConfig } from '@dfl/react-security';

class ImpersonateService extends EntityApiService<any> {
  impersonate = (space: string, params: any, config?: RequestConfig): Promise<any> => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/${space}`), params, config));
  };
}

export default new ImpersonateService('/ms-auth/api/auth/admin/impersonate');
